var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{staticClass:"html-editor",attrs:{"options":_vm.innerEditorConfig},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }